import { render, staticRenderFns } from "./liveVideoDialog.vue?vue&type=template&id=7fc65d40&scoped=true&"
import script from "./liveVideoDialog.vue?vue&type=script&lang=js&"
export * from "./liveVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./liveVideoDialog.vue?vue&type=style&index=0&id=7fc65d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc65d40",
  null
  
)

export default component.exports